import { useState } from 'react';
import { Grid3x3, Mic, MicOff, PhoneOff } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useSoftphone } from '@/lib/softphone/use-softphone';
import { Teclado } from './teclado';

export function ControlesDeLlamada() {
  const { state, hangUp, toggleMute, sendDigit } = useSoftphone();
  const [conTeclado, setConTeclado] = useState(false);
  const enLlamada = state.fase === 'in_call';

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="icon"
          aria-label={state.silenciado ? 'Activar micrófono' : 'Silenciar micrófono'}
          aria-pressed={state.silenciado}
          title={state.silenciado ? 'Activar micrófono' : 'Silenciar'}
          disabled={!enLlamada}
          onClick={toggleMute}
        >
          {state.silenciado ? <MicOff className="size-4" /> : <Mic className="size-4" />}
        </Button>
        <Button
          variant="outline"
          size="icon"
          aria-label="Teclado"
          aria-expanded={enLlamada && conTeclado}
          title="Teclado"
          disabled={!enLlamada}
          onClick={() => setConTeclado((abierto) => !abierto)}
        >
          <Grid3x3 className="size-4" />
        </Button>
        <Button variant="destructive" className="flex-1" onClick={hangUp}>
          <PhoneOff className="size-4" />
          Colgar
        </Button>
      </div>
      {enLlamada && conTeclado && <Teclado alMarcar={sendDigit} />}
    </div>
  );
}
